import React from 'react';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { SvgIcon, SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

type MediaIconProps = {
    className?: string;
    mimetype: string;
}

type Icons = { [k: string]: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> }
const icons: Icons = {
    'application/pdf': PictureAsPdfOutlinedIcon,
    'image/png': ImageOutlinedIcon,
    'image/jpg': ImageOutlinedIcon,
    'image/jpeg': ImageOutlinedIcon,
    'application/doc': DescriptionOutlinedIcon,
};

export const MediaIcon = ({ mimetype, className }: MediaIconProps) => {
    const iconElement = icons[mimetype];
    return <SvgIcon component={iconElement} width="100%" height="100%" className={className} />;
};
